import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import API_BASE_URL from './config';

// Set global base URL for all axios requests
axios.defaults.baseURL = API_BASE_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    // A 401 from the auth endpoints is "wrong password" / "bad credentials",
    // not "session expired". Redirecting on it reloads /login and wipes the
    // inline error message before the user can read it.
    const isAuthAttempt =
      url.includes('/api/auth/login') ||
      url.includes('/api/auth/register') ||
      url.includes('/api/auth/resend-verification');

    // Only a 401 from an authenticated request means the token is dead.
    // (403 is deliberately not handled here: the verification gate returns
    // 403 { requiresVerification: true } and the Login page renders it.)
    if (status === 401 && !isAuthAttempt) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Reloading /login when already there is a pointless flash; navigate
      // only if we are somewhere else.
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);
